export const esitoInvioEmailRadioButtons = [
    {text: "Email", value: "email"},
    {text: "Numero di telefono", value: "numeroTelefono"},
    {text: "ID lotto distribuzione", value: "idLotto"},
    {text: "Seriale", value: "seriale"}
]

export const esitoInvioEmailFilter = {
    tipoDiRichiesta: {
        label: "Tipo di richiesta",
        value: "",
    },
    idLotto: {
        label: "ID lotto spedizione",
        value: "",
    },
    numeroTelefono: {
        label: "Numero di Telefono",
        value: "",
    },
    seriale: {
        label: "Seriale",
        value: "",
    },
    email: {
        label: 'Indirizzo email',
        value: ""
    },
    dataInvio: {
        name: 'Data invio richiesta',
        from: null,
        to: null
    },
    esitoInvio: {
        label: 'Esito invio',
        value: ""
    }
}

export const sortingCriteria = [
    {text: "ID lotto", value: "requestId"},
    {text: "N. Telefono", value: "msisdn"},
    {text: "Seriale", value: "iccid"},
    {text: "Indirizzo email", value: "email"},
    {text: "Data invio", value: "creationDate"},
    {text: "Esito invio", value: "action"},
];